import {
  BibliographyTagRegisterData,
  BibliographyTagRegisterDataToJSON
} from '@/api/models'

export interface BibliographySetUpdateRequest {
  bibliographySetId?: number
  details: BibliographyTagRegisterData[]
  revision: number
}

export function BibliographySetUpdateRequestToJSON(
  value: BibliographySetUpdateRequest
): any {
  return {
    bibliography_set_id: value.bibliographySetId ?? undefined,
    details: value.details.map(BibliographyTagRegisterDataToJSON),
    revision: value.revision
  }
}
